import loadable from '@loadable/component'
import  { HomeLayout } from '../../Pages';
import { Navigate } from 'react-router-dom';

// query builder
const HomeViewComponent = loadable(() => import('../../Pages/Home/Views'), { resolveComponent: (components) => components.HomeView});
// Define Application Cutom Routes 
  export const RouteList = [
    {
      path: "/home",
      element: <HomeLayout/>,
      children: [
        { 
          path: '', 
          element: <HomeViewComponent/>
        },
        
      ]
    },
    {
      path:'',
      element: <Navigate to ='/home'/>
    }
    
  ];
  